module.exports = __webpack_public_path__ + "static/media/USDC.3b5972c1.svg";